module.exports = __webpack_public_path__ + "img/worteltaart-beslag-nat.229dde48.jpg";